import React from 'react'
import { NavLink } from 'react-router-dom'
import messageIcon from '../../icons/message2.svg'

const SignedInLinks = (props) => {
  var userPoints = 0;
  if(props.points && props.auth && props.points[props.auth.uid]){
    userPoints = 0;
      for(var point in props.points[props.auth.uid]){
        userPoints = userPoints + props.points[props.auth.uid][point];
      }
    }
  return (
    <div style={{"display":"flex","flexFlow":"row" }}>
      <div style={{"display":"flex","flexFlow":"row"}}>
        <div style={{"transform":"translate(5px,-20px)"}}>{userPoints}</div>
        <div className="userButton"><NavLink to={'/UserDashboard/' + props.auth.uid} className="btn btn-floating pink lighten-1">
          {props.profile.initials}
        </NavLink></div>
        {
          props.count !== 0 &&
        <div style={{"zIndex":"1001","transform":"translate(-5px,-19px)", "fontSize":"10px"}}>{props.count !== 0 && props.count}</div>
        }
        {
          props.count !== 0 &&
        <div style={{"width":"10px"}}><div style={{"transform":"translate(-15px,-12px)"}} className='messageIcon'><img src={messageIcon} className="favIcon" alt="message" width="22px" height="22px" viewBox="0 0 22 22"/></div></div>
        }
        {
          props.count == 0 &&
          <div style={{"width":"10px"}}/> 
        }
      </div>
    </div>
  )
}


export default (SignedInLinks)
